import { useState, useEffect } from "react";
import "./PlayPage.css";
import LineChart from "./LineChart";
import firebase from "../firebase";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles

function PlayPage() {
  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);

  const db = firebase.firestore();

  const [countValue, setCountValue] = useState([]);

  useEffect(() => {
    db.collection("votes")
      .orderBy("order", "desc")
      .onSnapshot((snapshot) =>
        setCountValue(snapshot.docs.map((doc) => doc.data()))
      );
  }, []);

  const arr = [];

  countValue.map(({ count }) => arr.push(count));

  const increment = firebase.firestore.FieldValue.increment(1);

  function DisableAll() {
    document.getElementsByName("Uninform")[0].disabled = true;
    document.getElementsByName("Poms")[0].disabled = true;
    document.getElementsByName("Vod")[0].disabled = true;
    document.getElementsByName("Soe")[0].disabled = true;
    document.getElementsByName("Guru")[0].disabled = true;
    var element = document.getElementById("NiceAlert");
    element.style.visibility = "visible";
  }

  function Uninform() {
    var storyRef = db.collection("votes").doc("uninformed");
    storyRef.update({ count: increment });
    console.log("you clocked uninformed");
    DisableAll();
  }
  function Poms() {
    console.log("you clocked Poms");
    var storyRef = db.collection("votes").doc("poms");
    storyRef.update({ count: increment });
    DisableAll();
  }
  function Vod() {
    console.log("you clocked Vod");
    var storyRef = db.collection("votes").doc("VOD");
    storyRef.update({ count: increment });
    DisableAll();
  }
  function Soe() {
    console.log("you clocked Soe");
    var storyRef = db.collection("votes").doc("SOE");
    storyRef.update({ count: increment });
    DisableAll();
  }
  function Guru() {
    console.log("you clocked Guru");
    var storyRef = db.collection("votes").doc("Guru");
    storyRef.update({ count: increment });
    DisableAll();
  }

  const userData = {
    labels: [
      "Uninformed",
      "Peak of 'Mount Stupid'",
      "Valley of Despair",
      "Slope of Enlightment",
      "Guru"
    ],
    datasets: [
      {
        label: "Coding",
        //data: UserData.map((data) => data.userGain),
        data: countValue.map(({ count }) => count),
        backgroundColor: ["white"],
        borderColor: "black",
        color: "#fff",
        borderWidth: 2
      }
    ]
  };

  // IF YOU SEE THIS COMMENT: I HAVE GOOD EYESIGHT

  return (
    <div className="App">
      <div></div>
      <div className="container">
        <div data-aos="fade-in" className="row">
          <h1>The Dunning Kruger Effect</h1>
        </div>
        <div data-aos="fade-in" className="row row-spacing">
          <blockquote className="otro-blockquote">
            “We’re living in a world in which we’re awash with information and
            misinformation. We live in a post-truth world.”
            <span>David Dunning</span>
          </blockquote>
        </div>

        <div data-aos="fade-in" className="makeSmall row row-spacing">
          <div className="col">
            <img
              style={{ width: 500, height: "auto" }}
              src="https://i.imgur.com/RjJMTfF.png"
              alt="dunningkrugermap"></img>
          </div>
          <div className="small-table col">
            <div style={{ width: 550, color: "white" }}>
              <LineChart chartData={userData} />
            </div>
          </div>
        </div>
        <div data-aos="fade-in" className="row row-spacing2">
          <div className="col">
            <div className="MainChart">
              <LineChart chartData={userData} />
            </div>
          </div>
        </div>
        <div data-aos="fade-in" className="row row-spacing">
          <div className="col">
            <h3 style={{ color: "darkblue" }}>
              Where are you in <span style={{ color: "black" }}>'Coding'?</span>
            </h3>
            <h4 style={{ color: "white", opacity: 0.4 }}>Cast Your Vote</h4>
          </div>
        </div>
        <div data-aos="fade-in" className="row row-spacing">
          <div className="col">
            <button
              type="button"
              name="Uninform"
              onClick={() => Uninform()}
              className="btn spacvote btn-outline-info">
              Uninformed
            </button>
          </div>
          <div className="col">
            <button
              type="button"
              name="Poms"
              onClick={() => Poms()}
              className="btn spacvote btn-outline-info">
              Peak of 'Mount Stupid'
            </button>
          </div>
          <div className="col">
            <button
              type="button"
              name="Vod"
              onClick={() => Vod()}
              className="btn spacvote btn-outline-info">
              Valley of Despair
            </button>
          </div>
          <div className="col">
            <button
              type="button"
              name="Soe"
              onClick={() => Soe()}
              className="btn spacvote btn-outline-info">
              Slope of Enlightment
            </button>
          </div>
          <div className="col">
            <button
              type="button"
              name="Guru"
              onClick={() => Guru()}
              className="btn spacvote btn-outline-info">
              Guru
            </button>
          </div>
        </div>
        <div className="row row-spacing">
          <div
            id="NiceAlert"
            style={{ visibility: "hidden" }}
            class="alert alert-success alert-dismissible fade show"
            role="alert">
            <strong>Nice!</strong> Your vote was counted.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayPage;
